export enum LabelPosition {
  Right = 'Right',
  Left = 'Left',
  TopLeft = 'TopLeft',
  TopCenter = 'TopCenter',
  TopRight = 'TopRight',
}
